'use strict';

angular.module('far.models.userMembership', [])
    .service('userMembership', function ($log, $http) {
        this.new = function (userData) {
            return new User(userData);
        };

        this.get = function (routeId, callback) {
            var route = new User({});

            $http.get(Routing.generate('api_entities_get_user', {user: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function User(userData) {
            angular.merge(this, userData);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (userData) {
                        angular.merge(this, userData);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        var objectToId = [
                            'country',
                        ];

                        for ( var key in objectToId ) {
                            var dataName = objectToId[ key ];

                            if ( angular.isObject( data[ dataName ] ) ) {
                                data[ dataName ] = data[ dataName ].id;
                            }
                        }

                        var objectToName = [
                            'region',
                            'city'
                        ];

                        for ( var key in objectToName ) {
                            var dataName = objectToName[ key ];

                            if ( angular.isObject( data[ dataName ] ) ) {
                                data[ dataName ] = data[ dataName ].name;
                            }
                        }

                        return $http.put(Routing.generate('api_entities_put_user_membership', {user: this.id}), data);
                    }
                }
            });
        }
    });
